import React, { useState } from 'react'
import UserMenuContainer from '../../containers/UserContainers/UserMenuContainer'
import Avatar from './avatar'

const Profile = ({ user, hasRoleIrriga, isCropMaster }) => {
  const [isToggleOn, setIsToggleOn] = useState(false)

  const toggleMenu = () => {
    setIsToggleOn(prevState => !prevState)
  }

  const closeMenu = () => {
    setIsToggleOn(false)
  }

  const shouldShowUserMenu = !hasRoleIrriga && isToggleOn

  return (
    <>
      <Avatar handleToggleMenu={toggleMenu} user={user} hasRoleIrriga={hasRoleIrriga} isCropMaster={isCropMaster} isMenuOpen={shouldShowUserMenu} />
      {shouldShowUserMenu && <UserMenuContainer onMenuClose={closeMenu} user={user} />}
    </>
  )
}

export default Profile
